import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { selectLdFlags } from '../../../redux/ld-flags';

export const BookingWidget = () => {
  const { shouldShowBookingWidgetLink } = useSelector(selectLdFlags);
  const widgetUrl = process?.env?.NEXT_PUBLIC_BOOKING_WIDGET_URL;

  return shouldShowBookingWidgetLink ? (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      size="large"
      href={widgetUrl}
    >
      Schedule a call
    </Button>
  ) : (
    <iframe
      src={widgetUrl}
      style={{ border: 0, height: 2110, width: '100%' }}
      title="Patient Scheduling Call"
    />
  );
};
